import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import CentralizedSpinner from 'components/CentralizedSpinner';
import PeriodSelect from 'components/Meteorology/Agro/WaterBalanceSequential/Maps/PeriodSelect';
import VariableSelect from 'components/Meteorology/Agro/WaterBalanceSequential/Maps/VariableSelect';
import MapDisplay from 'components/Meteorology/Agro/WaterBalanceSequential/Maps/MapDisplay';
import MapsMobile from 'components/Meteorology/Agro/WaterBalanceSequential/Maps/Mobile';
import useOptions from 'hooks/Meteorology/Agro/WaterBalanceSequential/Maps/useOptions';
import useIsMobile from 'utils/hooks/useIsMobile';
import Button from 'components/DesignSystem/Button';
import About from 'components/Meteorology/Agro/About';
import useMapDownload from 'hooks/Meteorology/Agro/WaterBalanceSequential/Maps/useMapDownload';

export default function Maps() {
  const [showAbout, setShowAbout] = useState(false);
  const isMobile = useIsMobile();
  const { isLoading } = useOptions();
  const {
    onDownloadClick,
    setOnDownloadClick,
    downloadDisabled,
    mapFilename,
  } = useMapDownload();

  if (isMobile) {
    return <MapsMobile />;
  }

  if (isLoading) {
    return <CentralizedSpinner />;
  }

  return (
    <>
      <About
        show={showAbout}
        onHide={() => setShowAbout(false)}
      />
      <Card className="content-card px-2">
        <Card.Body>
          <div className="d-flex mb-3">
            <VariableSelect />
            <PeriodSelect />
            <Button
              className="ms-auto mt-auto"
              type="tertiary"
              icon="download"
              onClick={onDownloadClick}
              disabled={downloadDisabled}
              id="water-balance-sequential-maps-download-button"
            />
            <Button
              id="water-balance-about"
              className="ms-2 mt-auto"
              icon="info"
              onClick={() => setShowAbout(true)}
            />
          </div>
          <MapDisplay
            setOnDownloadClick={setOnDownloadClick}
            mapFilename={mapFilename}
          />
        </Card.Body>
      </Card>
    </>
  );
}
